import BottomSection from './components/bottomSection/BottomSection';
import TopSection from './components/topSection/TopSection';

const Sections = () => (
  <>
    <TopSection />
    <BottomSection />
  </>
);

export default Sections;
